/** Domain service module: checkout.js */
import { request } from '../http/request'
import { API_BASE_URL } from './config'

class CheckoutService {
  initiate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/checkout/initiate`, 'post', data)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  cancel() {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/checkout/cancel`, 'post')
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  getPending(checkoutId) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/checkout/${checkoutId}`, 'get')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  prePayment(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/checkout/prePayment`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  pay(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/checkout/pay`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  checkPayment(checkoutId) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/checkout/checkPayment/${checkoutId}`, 'get')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  /** SSE status stream URL (EventSource opened by the view). */
  streamUrl(checkoutId, { timeout = 300, interval_ms = 1000 } = {}) {
    return `${API_BASE_URL}/checkout/${checkoutId}/stream?timeout=${timeout}&interval_ms=${interval_ms}`
  }
}

export const checkout = new CheckoutService()
export default checkout
